<kb-contact
  [name]="getName(contact)"
  [subline]="getSubline(contact)"
  [type]="type"
>
  @if (showImage && contact.type === 'person' && isPersonContactWithImage(contact)) {
    <img slot="picture" [src]="contact.image" alt="">
  }
  <p>
    @if (isContactWithLocation(contact)) {
      <app-address [address]="getAddress(contact)"></app-address>
      <br>
    }
    <app-contact-details [contactDetails]="contact"></app-contact-details>
  </p>
</kb-contact>
